import { render, staticRenderFns } from "./cartadeiservizi.vue?vue&type=template&id=a97e951a"
import script from "./cartadeiservizi.vue?vue&type=script&lang=js"
export * from "./cartadeiservizi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports